import { requestAPI } from 'utils/api'

export const createShopProduct = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/products/shop/product', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const validateShopProducts = (params: any) => {
  return requestAPI({
    method: 'POST', url: `/products/shop/product/validate`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const uploadShopProducts = (params: { [x: string]: any }[]) => {
  return requestAPI({
    method: 'POST', url: '/products/shop/product/import', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readshopProducts = (type?: string) => {
  return requestAPI({
    method: 'GET', url: '/products/shop/products', params: { type }
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateShopProduct = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/products/shop/product/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateProductGroup = (group_id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/products/shop/productgroup/${group_id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const upsertRakebackProducts = (id: any, params: { [x: string]: any }) => {
  return requestAPI({
    method: 'PATCH', url: `/products/shop/rakebackproducts/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteShopProduct = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/products/shop/product/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteRakebackProducts = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/products/shop/rakebackproducts/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createGroupProduct = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/products/group/product', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const validateGroupProducts = (params: any) => {
  return requestAPI({
    method: 'POST', url: `/products/group/product/validate`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const uploadGroupProducts = (params: { [x: string]: any }[]) => {
  return requestAPI({
    method: 'POST', url: '/products/group/product/import', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readGroupProducts = (isRaw?: boolean) => {
  return requestAPI({
    method: 'GET', url: '/products/group/products', params: { isRaw }
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateGroupProduct = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/products/group/product/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteGroupProduct = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/products/group/product/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createVipProduct = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/products/vip/product', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readVipProducts = (isRaw?: boolean) => {
  return requestAPI({
    method: 'GET', url: '/products/vip/products', params: { isRaw }
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateVipProduct = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/products/vip/product/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteVipProduct = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/products/vip/product/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createPayback = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/products/shop/payback', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readPayback = () => {
  return requestAPI({
    method: 'GET', url: '/products/shop/payback'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updatePaybackSections = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/products/payback/sections/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updatePaybackProducts = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/products/payback/products/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deletePaybackSubs = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/products/payback/subs/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updatePayback = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/products/shop/payback/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deletePayback = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/products/shop/payback/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}